/**
 * Use Alphanumeric order
 */
export default {
   assess_token: '',
   cart_products: [],
   chartOfAccounts: [],
   contacts: [],
   featureClasses: [],
   productFeatures: [],
   productLocations: [],
   users: {},
   shops: []
};




/** WEBPACK FOOTER **
 ** ./src/reducers/initialState.js
 **/